module.exports = __webpack_public_path__ + "static/media/close.8698cf50.svg";